import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMobileFriends = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 22,
	viewBox: "0 0 24 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M16.8252 1.09547C17.7932 1.34331 18.6511 1.90626 19.2638 2.69557C19.8765 3.48488 20.209 4.45565 20.209 5.45484C20.209 6.45404 19.8765 7.42481 19.2638 8.21412C18.6511 9.00343 17.7932 9.56638 16.8252 9.81422M22.9502 20.4492V17.6853C22.9502 17.53 22.9159 17.3759 22.8361 17.2427C22.4103 16.5315 21.3989 15.3536 19.9502 14.6292M16.9502 20.4492V17.6853C16.9502 17.53 16.9165 17.3771 16.8381 17.2431C16.0286 15.8598 13.5139 13.4492 8.9502 13.4492C4.38652 13.4492 1.87181 15.8598 1.06229 17.2431C0.983874 17.3771 0.950195 17.53 0.950195 17.6853V20.4492H16.9502ZM13.4502 5.44922C13.4502 7.9345 11.4355 9.94922 8.9502 9.94922C6.46491 9.94922 4.4502 7.9345 4.4502 5.44922C4.4502 2.96394 6.46491 0.949219 8.9502 0.949219C11.4355 0.949219 13.4502 2.96394 13.4502 5.44922Z",
		stroke: "#5583F6",
		strokeWidth: 1.9,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgMobileFriends;
